import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowLeft, BarChart3 } from "lucide-react";
import { useLocation } from "wouter";

export default function NotFound() {
  const [location, setLocation] = useLocation();

  return (
    <div className="min-h-screen bg-[var(--solar-bg)] flex items-center justify-center p-6">
      <div className="max-w-lg w-full text-center space-y-8">
        {/* Icon */}
        <div className="relative inline-flex">
          <div className="w-24 h-24 rounded-xl bg-[var(--brand-soft)] border border-[var(--solar-line)] flex items-center justify-center">
            <AlertTriangle className="w-12 h-12 text-[var(--brand)]" />
          </div>
          <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-white border border-[var(--solar-line)] shadow-[var(--elev-1)] flex items-center justify-center text-sm font-black text-[var(--brand)]">
            !
          </span>
        </div>

        {/* Text */}
        <div className="space-y-3">
          <h1 className="text-6xl font-black text-[var(--solar-ink)] tracking-tight">404</h1>
          <h2 className="text-xl font-semibold text-[var(--ink-2)]">Página não encontrada</h2>
          <p className="text-[var(--solar-mute)] leading-relaxed max-w-sm mx-auto">
            A página <code className="text-[var(--brand)] bg-[var(--brand-soft)] px-1.5 py-0.5 rounded text-sm">{location}</code> não existe ou foi movida.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => setLocation("/")}
            className="bg-[var(--solar-ink)] hover:opacity-90 text-white shadow-[var(--elev-1)] gap-2 font-semibold"
          >
            <BarChart3 className="w-4 h-4" />
            Ir para o Dashboard
          </Button>
          <Button
            onClick={() => history.back()}
            variant="outline"
            className="border-[var(--solar-line)] text-[var(--solar-ink)] hover:bg-[var(--secondary)] gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Button>
        </div>

        {/* Footer hint */}
        <p className="text-xs text-[var(--solar-mute)]">
          Se o problema persistir, verifique a URL ou entre em contato com o suporte SocialHub.
        </p>
      </div>
    </div>
  );
}
